// External dependencies.
import { __ } from '@wordpress/i18n';
import jQuery from 'jquery';
import moment from 'moment';

( function( $ ) {

	/**
	 * When Document is ready.
	 */
	$( document ).ready( function() {
		// When a confirm link clicked from email, show dialog and trigger change.
		if ( 'true' === new URLSearchParams( window.location.href ).get( 'confirm' )
			&& 'confirmed' !== $( '#_booking_status' ).val()
			&& confirm( __( 'Confirm the booking?' , 'woocommerce-bookings' ) ) ) {
				$(' #_booking_status' ).val( 'confirmed' );
				$(' #post' ).submit();
		}
	});

	/**
	 * Returns true if the date string is of the format
	 * yyyy-mm-dd, false otherwise.
	 *
	 * @param {string} dateString Date string.
	 * @return {boolean} date string is of a valid format or not.
	 */
	function isDateValidFormat( dateString = false ) {
		if ( false === dateString ) {
			return false;
		}

		return moment( dateString, 'YYYY-MM-DD', true ).isValid();
	}

	/**
	 * Returns true if the end date is before start date,
	 * false otherwise.
	 *
	 * @param {string} startDate The start date string
	 * @param {string} endDate The end date string
	 * @return {boolean} the end date is before start date or not.
	 */
	function isEndDateBeforeStartDate( startDate = '', endDate = '' ) {
		if ( 0 === startDate.length || 0 === endDate.length ) {
			return false;
		}

		return ! moment( endDate ).isBefore( startDate );
	}

	/**
	 * Renders the error message.
	 *
	 * @param {string} errorMessage The error message to be rendered.
	 */
	function renderError( errorMessage = '' ) {
		if ( 0 === errorMessage.length ) {
			return;
		}

		alert( errorMessage ); // eslint-disable-line
	}

	/**
	 * Client-side validation to check if start and end dates in
	 * Bookings > Add/Edit Booking is of the format yyyy-mm-dd.
	 *
	 * Prevents submission and displays error if the format is
	 * otherwise.
	 */
	const saveBookingBtn = $( '#woocommerce-booking-save input[name="save"]' );

	saveBookingBtn.on( 'click', function( e ) {
		const startDateEl = $( '#booking_start_date' );
		const endDateEl = $( '#booking_end_date' );
		const startDateValue = startDateEl.val();
		const endDateValue = endDateEl.val();

		if ( ! ( isDateValidFormat( startDateValue ) && isDateValidFormat( endDateValue ) ) ) {
			e.preventDefault();
			renderError( wc_bookings_admin_edit_booking_params.invalid_start_end_date );
			return;
		}

		if ( isDateValidFormat( startDateValue ) && isDateValidFormat( endDateValue ) && ! isEndDateBeforeStartDate( startDateValue, endDateValue ) ) {
			e.preventDefault();
			renderError( wc_bookings_admin_edit_booking_params.date_range_invalid );
		}
	} );
}( jQuery ) );
